import {
  WHOLESALER_PRODUCT_ADD_REQUEST,
  WHOLESALER_PRODUCT_ADD_SUCCESS,
  WHOLESALER_PRODUCT_ADD_FAILURE,
  WHOLESALER_PRODUCT_EDIT_REQUEST,
  WHOLESALER_PRODUCT_EDIT_SUCCESS,
  WHOLESALER_PRODUCT_EDIT_FAILURE,
  WHOLESALER_PRODUCT_VIEW_REQUEST,
  WHOLESALER_PRODUCT_VIEW_SUCCESS,
  WHOLESALER_PRODUCT_VIEW_FAILURE,
  WHOLESALER_PRODUCT_VIEW_ALL_REQUEST,
  WHOLESALER_PRODUCT_VIEW_ALL_SUCCESS,
  WHOLESALER_PRODUCT_VIEW_ALL_FAILURE,
  WHOLESALER_PRODUCT_DELETE_REQUEST,
  WHOLESALER_PRODUCT_DELETE_SUCCESS,
  WHOLESALER_PRODUCT_DELETE_FAILURE,
  WHOLESALER_PRODUCT_RESET_STATE,
  WHOLESALER_PRODUCT_SEARCH_REQUEST,
  WHOLESALER_PRODUCT_SEARCH_SUCCESS,
  WHOLESALER_PRODUCT_SEARCH_FAILURE,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SUCCESS,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_FAILURE,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_REQUEST,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_SUCCESS,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_REQUEST,
  WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_FAILURE,
} from "./WholesalerProductTypes";

// Add Wholesaler Product Actions
export const wholesalerProductAddRequest = (credentials) => ({
  type: WHOLESALER_PRODUCT_ADD_REQUEST,
  payload: credentials,
});

export const wholesalerProductAddSuccess = (wholesalerProduct) => ({
  type: WHOLESALER_PRODUCT_ADD_SUCCESS,
  payload: wholesalerProduct,
});

export const wholesalerProductAddFailure = (error) => ({
  type: WHOLESALER_PRODUCT_ADD_FAILURE,
  payload: error,
});

// Edit Wholesaler Product Actions
export const wholesalerProductEditRequest = (wholesalerProductId, updates) => ({
  type: WHOLESALER_PRODUCT_EDIT_REQUEST,
  payload: { wholesalerProductId, updates },
});

export const wholesalerProductEditSuccess = (wholesalerProduct) => ({
  type: WHOLESALER_PRODUCT_EDIT_SUCCESS,
  payload: wholesalerProduct,
});

export const wholesalerProductEditFailure = (error) => ({
  type: WHOLESALER_PRODUCT_EDIT_FAILURE,
  payload: error,
});

// View Wholesaler Product Actions By Wholesaler ID
export const wholesalerProductViewByWholesalerIdRequest = (
  wholesalerProductId,
  pageNo,
  search_key
) => ({
  type: WHOLESALER_PRODUCT_VIEW_WHOLESALERID_REQUEST,
  payload: { wholesalerProductId, pageNo, search_key },
});

export const wholesalerProductViewByWholesalerIdSuccess = (products) => ({
  type: WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SUCCESS,
  payload: products,
});
export const wholesalerProductByWholesalerIdViewFailure = (error) => ({
  type: WHOLESALER_PRODUCT_VIEW_WHOLESALERID_FAILURE,
  payload: error,
});

// View Wholesaler Product Search Actions By Wholesaler ID
export const wholesalerProductSearchViewByWholesalerIdRequest = (wholesalerProductId) => ({
  type: WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_REQUEST,
  payload: { wholesalerProductId },
});

export const wholesalerProductSearchViewByWholesalerIdSuccess = (products) => ({
  type: WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_SUCCESS,
  payload: products,
});

export const wholesalerProductSearchByWholesalerIdViewFailure = (error) => ({
  type: WHOLESALER_PRODUCT_VIEW_WHOLESALERID_SEARCH_FAILURE,
  payload: error,
});

// View Single Wholesaler Product Actions
export const wholesalerProductViewRequest = (wholesalerProductId) => ({
  type: WHOLESALER_PRODUCT_VIEW_REQUEST,
  payload: wholesalerProductId,
});

export const wholesalerProductViewSuccess = (wholesalerProduct) => ({
  type: WHOLESALER_PRODUCT_VIEW_SUCCESS,
  payload: wholesalerProduct,
});
export const wholesalerProductViewFailure = (error) => ({
  type: WHOLESALER_PRODUCT_VIEW_FAILURE,
  payload: error,
});

// View All Wholesaler Products Actions
export const wholesalerProductViewAllRequest = (pageNo) => ({
  type: WHOLESALER_PRODUCT_VIEW_ALL_REQUEST,
  payload: pageNo,
});

export const wholesalerProductViewAllSuccess = (wholesalerProducts) => ({
  type: WHOLESALER_PRODUCT_VIEW_ALL_SUCCESS,
  payload: wholesalerProducts,
});

export const wholesalerProductViewAllFailure = (error) => ({
  type: WHOLESALER_PRODUCT_VIEW_ALL_FAILURE,
  payload: error,
});

// View All Search Wholesaler Products Actions
export const wholesalerProductSearchViewAllRequest = () => ({
  type: WHOLESALER_PRODUCT_SEARCH_REQUEST,
});

export const wholesalerProductSearchViewAllSuccess = (wholesalerProducts) => ({
  type: WHOLESALER_PRODUCT_SEARCH_SUCCESS,
  payload: wholesalerProducts,
});

export const wholesalerProductSearchViewAllFailure = (error) => ({
  type: WHOLESALER_PRODUCT_SEARCH_FAILURE,
  payload: error,
});

// Delete Wholesaler Product Actions
export const wholesalerProductDeleteRequest = (wholesalerProductId) => ({
  type: WHOLESALER_PRODUCT_DELETE_REQUEST,
  payload: wholesalerProductId,
});

export const wholesalerProductDeleteSuccess = (wholesalerProductId) => ({
  type: WHOLESALER_PRODUCT_DELETE_SUCCESS,
  payload: wholesalerProductId,
});

export const wholesalerProductDeleteFailure = (error) => ({
  type: WHOLESALER_PRODUCT_DELETE_FAILURE,
  payload: error,
});

//Reset Wholesaler Product
export const wholesalerProductResetState = () => ({
  type: WHOLESALER_PRODUCT_RESET_STATE,
});
